import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import combine from './combine';

const store = createStore(combine, applyMiddleware(thunk));

export {store};